<template>
  <div class="dashboard-search-dialog">
    <custom-dialog class="afterSaleRole-item-dialog" width="400px" :title="model.title" :visible="visible" v-on="$listeners">
      <div class="dialog-body">
        <el-form :model="form" size="small" ref="form" label-position="top">
          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('base_dashboard_search_dialog.zu_lin_fang')" prop="ModemSN">
                <custom-select
                  v-model="form.customerId"
                  url="organRelationOrganList"
                  :listener="`${form.customerId || true}${form.customerName}`"
                  width="100%"
                  filterable
                  remote
                  :props="{ label: 'orgName', value: 'orgId',map: { orgName: 'customerName' } }"
                  :params="{ orgType: 'CS', queryNum: 50, search: form.customerName }"
                  :model="form"
                ></custom-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$t('base_dashboard_search_dialog.dai_li')" prop="websiteName">
                <custom-select
                  v-model="form.agentCoId"
                  url="organRelationOrganList"
                  :listener="`${form.agentCoId || true}${form.agentCoName}`"
                  width="100%"
                  filterable
                  remote
                  :props="{ label: 'orgName', value: 'orgId',map: { orgName: 'agentCoName' } }"
                  :params="{ orgType: 'JV,JV_SC', queryNum: 50, search: form.agentCoName }"
                  :model="form"
                ></custom-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$t('base_dashboard_search_dialog.shou_hou')" prop="websiteName">
                <custom-select
                  v-model="form.afterServiceId"
                  url="organRelationOrganList"
                  :listener="`${form.afterServiceId || true}${form.afterServiceName}`"
                  width="100%"
                  filterable
                  remote
                  :props="{ label: 'orgName', value: 'orgId',map: { orgName: 'afterServiceName' } }"
                  :params="{ orgType: 'SC,JV_SC', queryNum: 50, search: form.afterServiceName }"
                  :model="form"
                ></custom-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$t('base_dashboard_search_dialog.xiang_mu')" prop="websiteName">
                <custom-select
                  url="locationList"
                  :listener="`${form.locationId || true}${orgId}`"
                  filterable
                  remote
                  :model="form"
                  v-model="form.locationId"
                  :props="{ label: 'locationName', value: 'locationId',map: { locationName: 'locationName' }}"
                  :params="{ orgId: orgId,queryNum: 50, search: form.locationName}"
                  :placeholder="$t('Common.com_please_select')"
                  width="100%"
                ></custom-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="resetForm">{{ $t('Common.com_clear') }}</el-button>
        <el-button size="small" type="primary" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],

  data() {
    return {
      ossConfig: {},
      item: {},
      // visible: false,
      fileList: [],
      form: {
        customerId: '',
        customerName: '',
        agentCoId: '',
        agentCoName: '',
        afterServiceId: '',
        afterServiceName: '',
        locationName: '',
        locationId: '',
      },
    };
  },
  mounted() {
    this.resetFormSearch = JSON.stringify(this.form);
    this.initDialog();
  },
  computed: {
    orgId() {
      const userInfo = this.$store.state.userInfo;
      return userInfo ? userInfo.rootOrgId : '';
    },
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        // this.visible = true;
      });

      this.$setFormatData(this.form, this.model.data);

    },
    // 关闭弹窗
    closeDialog: function () {

      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
    // 清空
    resetForm: function () {
      this.form = JSON.parse(this.resetFormSearch);
    },
    // 确认保存
    confirm: function () {
      this.closeDialog();
      this.$emit('success', this.form);
    },
  },
};
</script>

<style lang="scss">
.dashboard-search-dialog {
  // 独立样式
  .el-dialog {
    overflow: hidden;
    border-radius: 16px !important;
    .el-dialog__header {
      padding: 0 20px;
      height: 72px;
      // background: #f8f9fa;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: 0;
      .el-dialog__title {
        color: #1a1a1a;
        font-size: 18px;
        font-weight: bold;
      }
      .el-dialog__headerbtn {
        height: 72px;
        width: 24px;
        position: relative;
        top: auto;
        right: auto;
        .el-icon-close {
          color: #202945;
          font-size: 20px;
          font-weight: bold;
        }
      }
    }
    .el-dialog__body {
      padding: 0 !important;
      // 弹窗
      .el-form-item {
        margin: 0 0 24px;
      }
      .el-form-item__label {
        font-weight: bold;
        font-size: 12px;
        line-height: 17px;
        margin-bottom: 4px;
        color: #1a1a1a;
      }
      .dialog-body {
        padding: 0 20px !important;
      }
      .el-input__inner{
        height: 40px;
        line-height: 40px;
        border: 1px solid #E6E6E6;
        border-radius: 8px;
        color: #818181;
        font-family: DIN 2014;
        font-size: 14px;
        font-weight: 400;

      }
      .el-form-item{
        margin-bottom: 16px;
      }
    }
    .el-dialog__footer{
      border: 0;
     .dialog-footer {
      margin: 4px 0 20px;
      height: 40px;
      padding: 0 20px;
      // background: #f8f9fa;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .el-button {
        width: calc(50% - 8px); /* 计算宽度为 50% 减去间距的一半 */
        height: 40px !important;
        line-height: 40px !important;

        font-family: DIN 2014;

        border-radius: 30px;
        span{
          font-size: 14px;
          font-weight: 700;
          color: #202945 !important;
        }
        &:first-child {
          border-color: #202945;

        }
        &:last-child {
          border-color: #FFAD00;
          background-color:  #FFAD00;

        }
      }
    }
    }

  }

  .title {
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
    line-height: 24px;
    font-size: 16px;
    margin-bottom: 24px;
  }
  .left {
    border-right: 1px solid #eef2f8;
    padding-right: 24px;
  }
  .right {
    padding-left: 24px;
  }
  .el-form-item--small.el-form-item {
    margin-bottom: 14px;
  }
}
</style>
